import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
const ApartmentField = t0 => {
  const $ = _c(20);
  let error;
  let handleBlur;
  let handleChange;
  let isTouched;
  let placeholder;
  let props;
  let showError;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      id: t1,
      name: t2,
      value,
      error,
      showError,
      isTouched,
      handleBlur,
      handleChange,
      placeholder,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = error;
    $[2] = handleBlur;
    $[3] = handleChange;
    $[4] = isTouched;
    $[5] = placeholder;
    $[6] = props;
    $[7] = showError;
    $[8] = t1;
    $[9] = t2;
    $[10] = value;
  } else {
    error = $[1];
    handleBlur = $[2];
    handleChange = $[3];
    isTouched = $[4];
    placeholder = $[5];
    props = $[6];
    showError = $[7];
    t1 = $[8];
    t2 = $[9];
    value = $[10];
  }
  const id = t1 === undefined ? "apartment" : t1;
  const name = t2 === undefined ? "apartment" : t2;
  const t3 = placeholder || "Apartment / suite # (optional)";
  const t4 = showError && isTouched && error ? error : null;
  let t5;
  if ($[11] !== handleBlur || $[12] !== handleChange || $[13] !== id || $[14] !== name || $[15] !== props || $[16] !== t3 || $[17] !== t4 || $[18] !== value) {
    t5 = <LabeledTextInput id={id} type="text" name={name} label={t3} onChange={handleChange} onBlur={handleBlur} value={value} autoComplete="address-line2" data-xc="shipping-apartment-field" {...props} errorMessage={t4} />;
    $[11] = handleBlur;
    $[12] = handleChange;
    $[13] = id;
    $[14] = name;
    $[15] = props;
    $[16] = t3;
    $[17] = t4;
    $[18] = value;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
ApartmentField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  showError: PropTypes.bool,
  value: PropTypes.string
};
export default ApartmentField;